export const routes = {
    dashboard: {
        path: "dashboard",
    },
    widgets: {
        path: "widgets",
    },
    templates: {
        path: "templates",
    },
    settings: {
        path: "settings",
    },
    headerFooterBuilder: { 
        path: "elementor-hf" 
    },
    onboarding: { 
        path: "onboarding" 
    }
}